// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TextWithTooltip_wrapper__rLd2I","text":"TextWithTooltip_text__1uRu1","tooltip":"TextWithTooltip_tooltip__2bp5d","fadeIn":"TextWithTooltip_fadeIn__1OrHc"};